import { buildApi } from '../util/api.util';

export const fattqueryapi = buildApi(process.env.REACT_APP_FATTQUERY_URL!);
